import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Md5 } from 'ts-md5/dist/md5';


@Component({
  selector: 'app-agent-user',
  templateUrl: './agent-user.component.html',
  styleUrls: ['./agent-user.component.css']
})
export class AgentUserComponent implements OnInit {

  public menu_item_id = '120';

  saveClicked = false;

  model = {
    'table_name': 'customer', 'customer_id': '0', 'customer_name': '', 'customer_name_en': '', 'acct_number': '', 
    'flag': 'update', 'key': 'customer_id', 'user_name': '', 'user_password': ''
  };

  Username_Msg; Pass_Msg; Pass_Rep_Msg; 
  Username_Exist_Msg; Success_Msg; Error_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<AgentUserComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, private router: Router,
    public translate: TranslateService) { 
      this.getMessages(translate);
  }

  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Username_Msg').subscribe((res: string) => {
      this.Username_Msg = res;
    });

    translate.get('Pass_Msg').subscribe((res: string) => {
      this.Pass_Msg = res;
    });

    translate.get('Pass_Rep_Msg').subscribe((res: string) => {
      this.Pass_Rep_Msg = res;
    });

    translate.get('Username_Exist_Msg').subscribe((res: string) => {
      this.Username_Exist_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {
    if (this.dialog_data != null) {
      this.model = this.dialog_data;

      (document.getElementById('user_name') as HTMLInputElement).disabled = (this.model['user_name'] != '');
    }
  }

  add() {
    this.saveClicked = true;

    if (this.model['change_pass'] == undefined && this.model['user_name'] == '') {
      alert(this.Username_Msg);
      (document.getElementById('user_name') as HTMLInputElement).focus();
      return;
    }

    if (this.model['user_password'] == '') {
      alert(this.Pass_Msg);
      (document.getElementById('user_password') as HTMLInputElement).focus();
      return;
    }

    if ((document.getElementById('repeat_password') as HTMLInputElement).value != this.model['user_password']) {
      alert(this.Pass_Rep_Msg);
      (document.getElementById('user_password') as HTMLInputElement).focus();
      return;
    }

    let values = [];
    let query, obj;


    if (this.model['change_pass'] == undefined) {
      // check if user name is exist
      query = "(SELECT `customer_id` AS `id`, `user_name` FROM `customer` WHERE `user_name` = '" + this.model['user_name'] + "') UNION " + 
        "(SELECT `user_id` AS `id`, `user_name` FROM `user` WHERE `user_name` = '" + this.model['user_name'] + "')";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            alert(this.Username_Exist_Msg);
            (document.getElementById('user_name') as HTMLInputElement).focus(); 
          }
          else {
            this.model['user_password'] = String(Md5.hashStr(this.model['user_password']));
            values.push(this.model);

            obj = { cmd: 'updateAdv', values: values };
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'success') {
                  alert(this.Success_Msg);
                  this.dialog_data = { 'op_type': 'success' };
                  this.dialogRef.close(this.dialog_data);
                }
                else
                  alert(this.Error_Msg);
              });
          }
        });
    }
    else {
      this.model['user_password'] = String(Md5.hashStr(this.model['user_password']));
      delete this.model['change_pass'];
      values.push(this.model);

      obj = { cmd: 'updateAdv', values: values };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else
            alert(this.Error_Msg);
        });
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
